import React from 'react';
import './SecondaryButton.css';

interface SecondaryButtonProps {
  label: string;
  clicked: any;
  disable?: boolean;
  className?: string;
  icon?: string | React.ReactNode;
  type?: 'delete' | 'normal' | 'logout';
  title?: string;
}
const SecondaryButton: React.FC<SecondaryButtonProps> = ({ label, clicked, disable = false, className = '', icon, type = 'normal', title }) => {
  const clickAction = (e: any) => {
    if (!disable) {
      clicked(e);
    }
  };

  const checkDisable = (disable: any, type: any) => {
    if (disable) {
      return ' row-wise secondary-button-disabled';
    } else if (type === 'delete') {
      return ' row-wise secondary-delete-button';
    } else if (type == 'logout') {
      return ' row-wise logout-btn';
    }
    return ' row-wise secondary-button';
  };
  return (
    <div
      title={title}
      className={className + checkDisable(disable, type)}
      onClick={(e: any) => {
        clickAction(e);
      }}>
      {icon ? (
        <span className="material-icons-round me-2" style={{ fontSize: '14px' }}>
          {icon}
        </span>
      ) : (
        ''
      )}
      <span>{label}</span>
    </div>
  );
};

export default SecondaryButton;
